import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const normalizeSearchTerm = (term) => {
  if (typeof term !== "string") {
    return "";
  }

  return term.trim().toLowerCase();
};

export const buildMatchSnippet = (text, term, maxLen = 90) => {
  const safeText = typeof text === "string" ? text : "";
  const normalizedTerm = normalizeSearchTerm(term);
  const normalizedText = safeText.trim();

  if (!normalizedText) {
    return "";
  }

  if (!normalizedTerm) {
    return normalizedText.length > maxLen ? `${normalizedText.slice(0, maxLen)}…` : normalizedText;
  }

  const lower = normalizedText.toLowerCase();
  const idx = lower.indexOf(normalizedTerm);

  if (idx === -1) {
    return normalizedText.length > maxLen ? `${normalizedText.slice(0, maxLen)}…` : normalizedText;
  }

  const context = Math.floor((maxLen - normalizedTerm.length) / 2);
  const start = Math.max(0, idx - context);
  const end = Math.min(normalizedText.length, idx + normalizedTerm.length + context);

  const prefix = start > 0 ? "…" : "";
  const suffix = end < normalizedText.length ? "…" : "";

  return `${prefix}${normalizedText.slice(start, end)}${suffix}`;
};

export const getMonthGroupKey = (dateInput) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) {
    return "invalid";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};

export const formatMonthGroupLabelPt = (dateInput) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const raw = format(date, "MMM 'de' yyyy", { locale: ptBR });
  const [monthPart, ...rest] = raw.split(" ");
  const month = (monthPart || "").toLowerCase();
  const monthWithDot = month.endsWith(".") ? month : `${month}.`;
  return `${monthWithDot} ${rest.join(" ")}`.trim();
};

export const groupMessagesByMonth = (messages = []) => {
  const groups = new Map();

  messages.forEach((message) => {
    const displayAt = message?.updatedAt || message?.createdAt;
    const key = getMonthGroupKey(displayAt);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        label: formatMonthGroupLabelPt(displayAt),
        items: [],
      });
    }
    groups.get(key).items.push(message);
  });

  // Preserve ordering already provided (we assume caller sorted desc).
  return Array.from(groups.values());
};
